import CartMessagesView from '../../views/library/cart-messages.view';
import * as React from 'react';
import { connect } from 'react-redux';
import { IPerformance, IZone } from '../../custom/classes/production';
import { IPackageListingAppState } from '../../redux-state/index';
import { removeItemFromCart, removeSelectedZone } from '../../redux-state/actions/package-listing.actions';
import { IPackageListingAppText } from '../../custom/classes/package-listing-text';
import { filterMap } from '../../helpers/map-helpers';
import { IPerformanceErrorMessage } from '../../../package-listing/classes/package-listing';
import { getGAPerfWithMissingZoneCount, isMixedReservation } from '../../helpers/cart-helpers';


interface StateToProps {
    text: IPackageListingAppText;
    groupName: string;
    maxReached: boolean;
    cartPerformanceCount: number;
    processPackageErrorMessage: string;
    packageMin: number;
    shouldRender: boolean;
}

interface ICartMessageExternalProps {
    performanceGroupId: number;
}

export type CartMessagesProps = StateToProps & ICartMessageExternalProps;

export class FiltersBase extends React.Component<CartMessagesProps, any> {
    constructor(props: CartMessagesProps) {
        super(props);
    }

    render() {
        return <CartMessagesView {...this.props} {...this.state} />;
    }
}

function mapStateToProps(state: IPackageListingAppState, ownProps: ICartMessageExternalProps): StateToProps {

    const requiresPerformanceGroups = state.packageListingSettings.isFixed ? false
        : (state.packageListing.packageDetail.performanceGroupDetails.length > 1
            && state.packageListing.packageDetail.performanceGroupDetails.filter(pg => pg.minimumPerformances > 0
                || pg.maximumPerformances != state.packageListing.packageDetail.maximumPerformances).length > 0);

    var processError: Array<IPerformanceErrorMessage> = [];
    if (state.packageListing.errorMessages != undefined)
        processError = state.packageListing.errorMessages.filter(err => err.performanceId === 0);

    if (requiresPerformanceGroups) {

        if (ownProps.performanceGroupId == null)
            return {} as any;
        else {
            var matchedPerfGroup = state.packageListing.packageDetail.performanceGroupDetails.filter(group => group.id === ownProps.performanceGroupId)[0];
            var groupPerfIds = [];
            if (matchedPerfGroup) {
                groupPerfIds = matchedPerfGroup.tessPerformances.map(perf => perf.performanceId);
            }

            const cartPerfs = filterMap(state.packageListing.cartItems, (perf) => groupPerfIds.indexOf(perf) >= 0);

            const groupMax = matchedPerfGroup.maximumPerformances == null ? state.packageListing.packageDetail.maximumPerformances
                : matchedPerfGroup.maximumPerformances;

            let cartPerformanceCount = cartPerfs.size;
            if (isMixedReservation(state)) {
                let gaPerfsWithMissingZones = getGAPerfWithMissingZoneCount(state, cartPerfs as Map<number, number>);
                if (gaPerfsWithMissingZones > 0) {
                    cartPerformanceCount = matchedPerfGroup.minimumPerformances - gaPerfsWithMissingZones;
                }
            }
            else if (state.packageListingSettings.useUnseatedReservation) {
                cartPerformanceCount = Array.from(cartPerfs.values()).filter(zoneId => zoneId > 0).length
            }
            return {
                text: state.packageListingText,
                processPackageErrorMessage: processError.length > 0 ? processError[0].errorMessage : "",
                cartPerformanceCount: cartPerformanceCount,
                maxReached: cartPerfs.size >= groupMax,
                packageMin: matchedPerfGroup.minimumPerformances,
                groupName: matchedPerfGroup.description,
                shouldRender: true
            }
        }

    } else {
        let cartPerformanceCount = state.packageListing.cartItems.size;
        if (isMixedReservation(state)) {
            let gaPerfsWithMissingZones = getGAPerfWithMissingZoneCount(state, state.packageListing.cartItems);
            if (gaPerfsWithMissingZones > 0) {
                cartPerformanceCount = state.packageListing.packageDetail.minimumPerformances - gaPerfsWithMissingZones;
            }
        }
        else if (state.packageListingSettings.useUnseatedReservation) {
            cartPerformanceCount = Array.from(state.packageListing.cartItems.values()).filter(zoneId => zoneId > 0).length;
        }

        return {
            text: state.packageListingText,
            processPackageErrorMessage: processError.length > 0 ? processError[0].errorMessage : "",
            cartPerformanceCount: cartPerformanceCount,
            maxReached: state.packageListingSettings.isFixed ? false : (state.packageListing.cartItems.size >= state.packageListing.packageDetail.maximumPerformances),
            packageMin: state.packageListingSettings.isFixed ? 0 : (state.packageListing.packageDetail.minimumPerformances),
            groupName: "",
            shouldRender: true
        }
    }
}


export default connect<StateToProps>(mapStateToProps)(FiltersBase);